//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
const MatchManagerConvertor = require('@/tbs/model/vo/MatchManager')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_MatchSignupConfigMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_MatchSignupConfigMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_MatchSignupConfigMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    handleCreationComplete: function() {
        if (this._bridge.isDetail()) {
            this.loadMatchGroupByMatch(this._bridge.getRouteParam('id'))
        }
        else if (this._bridge.isEdit()) {
            this.creationComplete()
        }
    },
    loadMatchGroupByMatch(matchId) {
        console.log('loadMatchGroupByMatch', matchId)
        const self = this
        self.loadViewObjectData(new MatchManagerConvertor, {id: matchId}, function(data) {
            console.log('loadMatchGroupByMatch', data, data.match.matchGroupId)
            self.matchGroupId = data.match.matchGroupId
            console.log('@matchGroupId', self.matchGroupId)
            self.creationComplete({parameters: {matchGroupId: self.matchGroupId}})
        }, 'manage')
    },
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_MatchSignupConfigMediator, BaseMediator);

module.exports = tbs_controller_MatchSignupConfigMediator